import { z } from "zod";
import { gql } from "graphql-request";

export const Image = z
  .object({
    title: z.string().nullable(),
    url: z.string().url().nullable(),
    width: z.number().nullable(),
    height: z.number().nullable(),
  })
  .default({
    title: null,
    url: null,
    width: null,
    height: null,
  });

export type Image = z.infer<typeof Image>;

export const ImageFragment = gql`
  fragment ImageFragment on Asset {
    title
    width
    height
    url
  }
`;
